module.exports = __webpack_public_path__ + "media/hydrocompression.df582e2d.mp3";